import Uiconstants from '../../lib/UIconstants';
import SoundController from '../../controllers/SoundController';
import SettingsController from '../../controllers/settings/SettingsController';
import InfoController from '../../controllers/info/InfoController';
import { COMPONENTS } from '../../lib/constants';
export const InfoButtons = {
	name: COMPONENTS.INFO_BUTTONS,
	position: {
		x: 1732,
		y: 86
	},
	controllers: [
		{
			Controller: SoundController,
			name: 'ui_sound_on',
			config: {
				soundon: 'ui_sound_on',
				soundoff: 'ui_sound_off'
			}
		},
		{
			Controller: SettingsController,
			name: 'ui_settings',
			config: {
				modal: 'ui_settings',
				item: COMPONENTS.SETTINGS_PAGE
			}
		},
		{
			Controller: InfoController,
			name: 'ui_info',
			config: {
				modal: 'ui_info',
				item: COMPONENTS.INFO_PAGE
			}
		}
	],
	components: [
		{
			name: 'infobuttons',
			type: 'Sprite',
			components: [
				{
					name: Uiconstants.BTN_SOUND_ON,
					type: 'SimpleButton',
					bg: 'header_sound_on',
					position: { x: 18, y: 25 }
				},
				{
					name: Uiconstants.BTN_SOUND_OFF,
					type: 'SimpleButton',
					bg: 'header_sound_off',
					position: { x: 18, y: 25 }
				},
				{
					name: Uiconstants.BTN_SETTINGS,
					type: 'SimpleButton',
					bg: 'header_settings_icon',
					position: { x: 150, y: 25 }
				},
				{
					name: Uiconstants.BTN_INFO,
					type: 'SimpleButton',
					bg: 'header_info_icon',
					position: { x: 85, y: 25 }
				}
			]
		}
	]
};
